import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  EntityService,
  IToken,
  TOKEN_KEYS,
  TokenService,
  User
} from 'viggo-sistemas-core-web';
import { ILogin } from 'viggo-sistemas-core-web/modules/auth/model/login.model';
import { IRole } from 'viggo-sistemas-core-web/modules/role/model/role.model';

@Injectable()
export class AuthService extends EntityService<IToken> {
  constructor(
    public snackBar: MatSnackBar,
    public router: Router,

    protected tokenService: TokenService
  ) {
    super({
      baseEntityEndPoint: 'token',
      urlBackend: environment.backendURL_HOMO
    });
  }

  /**
   * Função padrão de login, porém recebendo uma flag a mais de remove_tokens
   * @param login
   * @returns
   */
  login(login: ILogin): Observable<{ token: IToken }> {
    return this.http.post<{ token: IToken }>(
      localStorage.getItem(TOKEN_KEYS.URL_API) + 'tokens',
      JSON.stringify(login),
      {
        headers: this.getHeader()
      }
    );
  }

  /**
   * Realiza a caputra de informação referente ao usuário logado
   * é o processo posteriror ao login forçado
   * @param id
   * @param include
   * @returns
   */
  public getUserEntity(
    id: string,
    include?: string | string[]
  ): Observable<{ user: User }> {
    const url = `${localStorage.getItem(TOKEN_KEYS.URL_API)}users/${id}`;
    let params = new HttpParams();
    if (include)
      params = params.set(
        'include',
        Array.isArray(include) ? include.join(',') : include
      );

    return this.http.get<{ user: User }>(url, {
      headers: this.getHeader(),
      params
    });
  }

  public getRoules(userId: string): Observable<IRole[]> {
    return this.http
      .get<{ roles: IRole[] }>(
        `${localStorage.getItem(TOKEN_KEYS.URL_API)}users/${userId}/roles`,
        {
          headers: this.getHeader()
        }
      )
      .pipe(
        map(data => data.roles),
        catchError(this.handleError)
      );
  }

  /**
   * Salva as informações no  localStorage
   */
  onLoginUserInfo(user_id: string) {
    this.getUserEntity(user_id, [
      'domain.application',
      'domain.addresses.municipio',
      'domain.addresses.pais'
    ])
      .pipe(
        mergeMap(user => {
          return this.getRoules(user_id).pipe(
            map(roles => {
              user.user.roles = roles;
              return { ...user };
            })
          );
        })
      )
      .subscribe(
        value => {
          this.tokenService.saveUser(value.user);
          this.tokenService.saveDomain(value.user.domain);
          this.snackBar.open(
            `Logado com sucesso! Bem-vindo ${value.user.name}`,
            'X',
            {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            }
          );
        },
        () => {
          this.snackBar.open(
            'Estamos com problemas para acessar suas permissões!',
            'X',
            {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            }
          );
        },
        () => this.router.navigate(['workspace'])
      );
  }
}
